export const JOURNAL_STORAGE_KEY = 'sbTrackerJournal';
export const JOURNAL_MAX_EVENTS = 200;
export const JOURNAL_MAX_BYTES = 50_000;
export const SESSION_STORAGE_KEY = 'sbTrackerSession';
export const SESSION_TTL_MS = 1_800_000; // 30-min rolling inactivity window
export const CONSENT_REQUIRED_COOKIE = 'cookie_consent_required';

/**
 * Overflow cap for the `X-SB-*` header set — a client-side best-effort margin,
 * not a guarantee: it measures only the tracker's own headers, not the cookies
 * and request line the browser adds. 6_000 leaves ~2192 B below the ~8192 proxy
 * header-line limit for those; the real limit is the server's header-buffer size.
 * On overflow, payload headers drop largest-first; fixed headers never drop.
 */
export const MAX_HEADER_BYTES = 6_000;

/** Prefix for every tracker request header (identity, event, and payload). */
export const HEADER_PREFIX = 'X-SB-';

/**
 * Fixed (non-payload) header names. Named here to avoid magic strings at the
 * call sites in transport.ts. nginx lowercases these into `$http_*` vars with
 * `-`→`_` (e.g. `X-SB-Event-Type` → `$http_x_sb_event_type`).
 */
export const FIXED_HEADERS = {
    SESSION_ID: 'X-SB-Session-Id',
    USER_ID: 'X-SB-User-Id',
    DEVICE: 'X-SB-Device',
    PAGE_TYPE: 'X-SB-Page-Type',
    EVENT_TYPE: 'X-SB-Event-Type',
    EVENT_TIMESTAMP: 'X-SB-Event-Timestamp',
} as const;

/**
 * Ingest endpoint holder. Defaults to the DevOps-approved `/api/event` path
 * (confirmed unreserved in core-webapp, served by nginx). `setEndpoint`/`getEndpoint`
 * remain so tests and other environments can override the default.
 */
let endpoint = '/api/event';

export const setEndpoint = (url: string): void => {
    endpoint = url;
};

export const getEndpoint = (): string => endpoint;
